import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { CompanyfacilityService } from '@app/service/companyfacility.service';
import { ReceptionService } from '@app/service/reception.service';

import * as $ from 'jquery';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-print-facility-receipt',
  templateUrl: './print-facility-receipt.component.html',
  styleUrls: ['./print-facility-receipt.component.scss']
})
export class PrintFacilityReceiptComponent implements OnInit {

  private params: any;

  public dataList: any = [];

  public year: any = moment().format('YYYY');
  public month: any = moment().format('MM');
  public day: any = moment().format('DD');

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  constructor(
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private companyfacilityService: CompanyfacilityService,
    private receptionService: ReceptionService,
  ) { }

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  ngOnInit() {
    // 파라미터 가져오기
    this.params = sessionStorage.getItem( 'inspectFacilityPrintReceipt' );
    sessionStorage.removeItem( 'inspectFacilityPrintReceipt' );

    this.getPrintReceiptList();
  }

  /*******************************************************************************
    설  명 : view 로딩 후 생성자
  *******************************************************************************/
  ngAfterViewInit() {
    var data = $(".table tbody").children();
    setTimeout (() => {
      if( typeof data[0] !== undefined ) {
        window.print();
      }
    }, 500);
  }

  /*******************************************************************************
    설  명 : 접수증 데이터 리스트 가져오기
  *******************************************************************************/
  getPrintReceiptList() {
    this.receptionService.getPrintReceiptList( this.params ).then( response => {
      //console.log(response);
      if( response.ResultCode ) {
        this.dataList = response.data;
      } else {
        this.toastrService.error( response.ResultMessage, '');
      }
    });
  }

}
